import { OrderFailReason } from '@bts-web/data-layer/server';

export const orderFailReasonTranslationKeys: Record<OrderFailReason, string> = {
  CANCELLED_BY_USER: 'notifications.order.canceled.user_canceled.title_@tenant',
  EXPIRED: 'notifications.order.canceled.expired.title_@tenant',
  CANCELLED_DUE_TO_ASSET_DISABLING:
    'notifications.order.failed.asset_disabled.title_@tenant',
  ORDER_EXECUTION_ERROR:
    'notifications.order.failed.internal_error.title_@tenant',
  SLIPPAGE_EVALUATION:
    'notifications.order.failed.internal_error.title_@tenant',
  USER_ACCOUNT_INACTIVE:
    'notifications.order.failed.internal_error.title_@tenant',
  USER_TRANSACTION_INACTIVE_CRYPTOCOIN:
    'notifications.order.failed.internal_error.title_@tenant',
  USER_TRANSACTION_OPERATIONS_DISABLED:
    'notifications.order.failed.internal_error.title_@tenant',
  USER_TRANSACTION_TRADING_DISABLED:
    'notifications.order.failed.internal_error.title_@tenant',
};
